import { render, staticRenderFns } from "./leftList.vue?vue&type=template&id=20547530&scoped=true&"
import script from "./leftList.vue?vue&type=script&lang=js&"
export * from "./leftList.vue?vue&type=script&lang=js&"
import style0 from "./leftList.vue?vue&type=style&index=0&id=20547530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20547530",
  null
  
)

export default component.exports